export const TREE_NODE_BAR_CONTROL = Symbol('TREE_NODE_BAR_CONTROL');

export const TREE_NODE_LIST_ROOTS_REFETCH = Symbol('TREE_NODE_LIST_ROOTS_REFETCH');

export type TreeNodeListRootsRefetch = () => Promise<void>;
